import {
  CHANGE_PERSONAL_DEFAULT,
  CHANGE_PERSONAL_DEFAULT_FAILED,
  CHANGE_PERSONAL_DEFAULT_SUCCESS,
  CLEAR_DOCUMENT_REPOSITORY_DETAILS,
  CLEAR_DOCUMENT_REPOSITORY_STORE,
  FETCH_DOCUMENT_REPOSITORIES_SUCCESS,
  FETCH_DOCUMENT_REPOSITORY_DETAILS_SUCCESS,
  FETCH_SELECTED_DOCUMENTS,
  FETCH_SELECTED_DOCUMENTS_FAILED,
  FETCH_SELECTED_DOCUMENTS_SUCCESS,
} from '../actions/DocumentRepositoryActions';

const initialState = {
  documentRepositories: [],
  documentRepositoryDetails: {},
  defaultRepository: '',
  loading: false,
  isDefaultSetForUser: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_REPOSITORIES_SUCCESS:
      return {
        ...state,
        documentRepositories: action.payload.repositories,
        isDefaultSetForUser: action.payload.isDefaultSetForUser,
        defaultRepository: action.payload.defaultRepository,
      };

    case FETCH_DOCUMENT_REPOSITORY_DETAILS_SUCCESS:
      return {
        ...state,
        documentRepositoryDetails: action.payload.data,
      };

    case CHANGE_PERSONAL_DEFAULT_SUCCESS:
      return {
        ...state,
        defaultRepository: action.payload.data,
        loading: false,
      };

    case FETCH_SELECTED_DOCUMENTS:
    case CHANGE_PERSONAL_DEFAULT:
      return {
        ...state,
        loading: true,
      };

    case FETCH_SELECTED_DOCUMENTS_SUCCESS:
    case FETCH_SELECTED_DOCUMENTS_FAILED:
    case CHANGE_PERSONAL_DEFAULT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case CLEAR_DOCUMENT_REPOSITORY_DETAILS:
      return {
        ...state,
        documentRepositoryDetails: {},
      };

    case CLEAR_DOCUMENT_REPOSITORY_STORE: {
      return initialState;
    }

    default:
      return state;
  }
};
